import { z } from 'zod'
import { AppealsStatusSchema } from './appeals.schema'
export function getAppealStatusText(status: number) {
  switch (status) {
    case 0:
      return 'Pending Review' as const
    case 1:
      return 'Under Review' as const
    case 2:
      return 'Awaiting Documentation' as const
    case 3:
      return 'Approved' as const
    case 4:
      return 'Denied' as const
    case 5:
      return 'Resolved' as const
    case 6:
      return 'Incomplete' as const
    case 7:
      return 'Withdraw' as const
    case 8:
      return 'Escalated' as const
    case 9:
      return 'Closed' as const
    case 10:
      return 'Appeal In Committee' as const
    case 11:
      return 'Appeal In Review' as const

    default:
      return ''
  }
}

const AppealStudentSchema = z.object({
  id: z.number(),
  status: z.number().nullable(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  date_of_birth: z.string().nullable(),
  grade: z.string().nullable(),
  relationship: z.string().nullable(),
  competing_scholarship_ids: z.array(z.number()).min(0),
  lea_participation: z.number(),
  withdrawn_by: z.number().nullable(),
  created_by: z.number().nullable(),
  created_on: z.number().nullable(),
  created_datetime: z.string(),
  last_by: z.number().nullable(),
  last_on: z.number().nullable(),
  last_datetime: z.string().nullable(),
  deleted_at: z.string().nullable(),
})

const AppealFlagSchema = z.object({
  id: z.number(),
  status: z.number().transform((val) => {
    switch (val) {
      case 0:
        return 'Pending Review'
      case 1:
        return 'Approved'
      case 2:
        return 'Denied'
    }
  }),
  global_application_flag_id: z.number(),
  application_id: z.number(),
  student_id: z.number().nullable(),
  reasoning: z.number(),
  justification: z.string().nullable(),
  created_by: z.number().nullable(),
  created_on: z.number().nullable(),
  name: z.string().nullable(),
  created_datetime: z.string(),
  last_by: z.number().nullable(),
  last_on: z.number().nullable(),
  last_datetime: z.string().nullable(),
  students: z.array(AppealStudentSchema).min(0),
})

export const ApplicationAppealDetailSchema = z.object({
  id: z.number(),
  date_filed: z.string(),
  case_number: z.number(),
  reason: z.string(),
  appeal_status: AppealsStatusSchema,
  contact_preference: z.string().nullable(),
  comments: z.string().nullable(),
  review_outcome: z.number(),
  outcome_reasoning: z.number(),
  resolution_message: z.string().nullable(),
  application_id: z.number(),
  days_in_appeal: z.number(),
  type_code: z.string(),
  date_resolved: z.string().nullable(),
  student_name: z.string().nullable(),
  applicant_name: z.string(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  flags: z.array(AppealFlagSchema).min(0),
  flag: AppealFlagSchema.nullable(),
  documents: z
    .array(
      z.object({
        id: z.number(),
        document_type: z.number(),
        application_appeal_id: z.number(),
        path: z.string(),
        created_at: z.string(),
        updated_at: z.string().nullable(),
      })
    )
    .min(0),
})

export type ApplicationAppealDetail = z.infer<
  typeof ApplicationAppealDetailSchema
>
